import {
    RaikoBaseCardContainer,
    RaikoBaseContainer,
    RaikoBreadcrumb,
    raikoBreadCrumbItemGenerator,
    RaikoCustomTable,
    RaikoGridOneColumn,
    RaikoTableTitleContainer,
    showErrorMessage,
    convertUniversalDateToPersianDate,
    convertCurrencyFormatPositiveNegative,
    RaikoSectionContainer,
    RaikoGridTwoColumn,
    RaikoDatePicker
} from "@moeindal/base-raiko-panel-components";
import {css} from "@emotion/css";
import {RouteHelper, RouteInfo} from "../../route/RouteHelper";
import {useEffect, useRef, useState} from "react";
import useDraggableScroll from "use-draggable-scroll";
import React from "react";
import PointsStatistics from "../../raicheComponents/statistics/PointsStatistics";
import {UnionService} from "../../serverService/unionService/UnionService";
import {useAuthState} from "../../context/AuthContext";
import {LoadingHelper} from "../../util/LoadingHelper";
import {useLoadingDispatcher} from "../../context/LoadingContext";
import {detectServerErrorMessage} from "../../util/detectServerErrorMessage";
import {useSearchParams} from "react-router-dom";
import {useDebounce} from "@uidotdev/usehooks";
import "../dashboard/Dashboard.scss"

export default function Union() {
    //drag-start
    const ref = useRef(null);
    const {onMouseDown} = useDraggableScroll(ref, {direction: 'horizontal'});
    //drag-end
    const [searchParams, setSearchParams] = useSearchParams()
    const [page, setPage] = useState(searchParams.get("page") || 0)
    const size = 20
    const [isLoading, setIsLoading] = useState(false);
    const [transactionList, setTransactionList] = useState([]);
    const [summationOfAmount, setSummationOfAmount] = useState("")
    const [pageCount, setPageCount] = useState(0);

    const [startDateFilter, setStartDateFilter] = useState(searchParams.get("startDateFilter") || "");
    const [endDateFilter, setEndDateFilter] = useState(searchParams.get("endDateFilter") || "");

    const _startDateFilter = useDebounce(startDateFilter, 500)
    const _endDateFilter = useDebounce(endDateFilter, 500)

    const {fundID} = useAuthState()

    const service = new UnionService()

    const loading = new LoadingHelper(useLoadingDispatcher())


    useEffect(() => {
        if (typeof service !== "undefined") {
            getUnionBasicInformationFromServer()
            getUnionTransactionsList()
        }
    }, [_startDateFilter, _endDateFilter,fundID])

    const [reports, setReports] = useState({
        totalCashBalance: 0,
        totalBalance: 0,
        investmentMonths: 0,
        totalUnionBalance: 0,
        unionAverageBalance: 0,
    })

    function getUnionBasicInformationFromServer() {
        loading.show()
        service.getUnionBasicInformation(fundID)
            .then(response => {
                setReports(response)
            }).catch(reason => {
            showErrorMessage(detectServerErrorMessage(reason))
        }).finally(_ => {
            loading.hide()
        })
    }

    function handleChangePagination(newPage) {
        setPage(newPage)
    }


    function tablePreparation(id, number, amount, date) {
        return {
            id: id,
            number: number,
            amount: amount ? convertCurrencyFormatPositiveNegative(amount) : "0",
            date: date ? convertUniversalDateToPersianDate(date) : "-"
        }
    }


    function getUnionTransactionsList() {
        setIsLoading(true)

        service.getFundTransactions(fundID, page, size, _startDateFilter, _endDateFilter)
            .then(response => {
                setPageCount(response.totalPage)
                setTransactionList([])
                response.data.map((item, index) => {
                    setTransactionList(prevState => [
                        ...prevState,
                        tablePreparation(
                            item.id,
                            (page * size) + index + 1,
                            item.amount,
                            item.date
                        )
                    ])
                })
                setSummationOfAmount(response.summationOfAmounts)
            }).catch(reason => {
            showErrorMessage(detectServerErrorMessage(reason))
        }).finally(_ => {
            setIsLoading(false)
        })
    }

    return (
        <RaikoBaseContainer>
            <RaikoGridOneColumn className={css`gap: 1.5rem;`}>
                <RaikoBreadcrumb breadCrumbItems={[
                    raikoBreadCrumbItemGenerator(
                        RouteHelper.Union.name,
                        RouteHelper.Union.globalUrl
                    )
                ]}/>
                <div className="statisticsLayout hideScroll" ref={ref} onMouseDown={onMouseDown}>
                    <PointsStatistics
                        title={"موجودی صندوق (ریال)"}
                        amount={reports.totalCashBalance}
                    />
                    <PointsStatistics
                        title={"موجودی نقد صندوق (ریال)"}
                        amount={reports.totalBalance}
                    />
                    <PointsStatistics
                        title={"ماه سرمایه گذاری"}
                        amount={reports.investmentMonths}
                    />
                    <PointsStatistics
                        title={"مجموع سرمایه گذاری (ریال)"}
                        amount={reports.totalUnionBalance}
                    />
                    <PointsStatistics
                        title={"میانگین سرمایه گذاری (ریال)"}
                        amount={reports.unionAverageBalance}
                    />
                </div>
                <RaikoBaseCardContainer>
                    <RaikoSectionContainer
                        title={"جستجو"}
                        subTitle={"برای جستجو عبارت مورد نظر خود را وارد نمایید."}
                    >
                        <RaikoGridTwoColumn>
                            <RaikoDatePicker
                                label={"تاریخ شروع"}
                                date={startDateFilter}
                                setDate={setStartDateFilter}/>
                            <RaikoDatePicker
                                label={"تاریخ پایان"}
                                date={endDateFilter}
                                setDate={setEndDateFilter}/>
                        </RaikoGridTwoColumn>
                    </RaikoSectionContainer>
                </RaikoBaseCardContainer>
                <RaikoBaseCardContainer>
                    <RaikoGridOneColumn>
                        <RaikoTableTitleContainer title={"سابقه تراکنشات"}/>
                        <RaikoCustomTable
                            isLoading={isLoading}
                            data={transactionList}
                            header={unionDetailTableHeader}
                            handlePaginationChange={handleChangePagination}
                            pageCount={pageCount}
                            summationOfAmount={summationOfAmount}
                        />


                    </RaikoGridOneColumn>
                </RaikoBaseCardContainer>

            </RaikoGridOneColumn>
        </RaikoBaseContainer>
    )
}
export const unionDetailTableHeader = [
    {
        id: 'number',
        label: '#',
    },
    {
        id: 'amount',
        label: 'مبلغ (ریال)',
    },
    {
        id: 'date',
        label: 'تاریخ واریز',
    },
]